import React from 'react'
import Founders from './Founders'
import Team from './Team'
import ContactUs from './ContactUs'
import './AboutUs.css'

const About: React.FC = () => (
    <div className="main-content about-us-wrapper">
        <Founders />
        <Team />
        <ContactUs />
    </div>
)

export default About
